import { connect } from "react-redux";
import { useEffect, useMemo, useState } from "react";

import Modal from "@components/Modal";
import StoresFilters from "@components/ProductPage/ProductStoreAvailability/StoresFilters";
import StoresList from "@components/ProductPage/ProductStoreAvailability/StoresList";
import StoreSelectModalStoreCard from "@components/ProductPage/ProductStoreAvailability/StoreSelectModal/StoreSelectModalStoreCard";
import { getRegions } from "@store/user/actions";
import { getStores } from "@store/stores/actions";
import Loading from "@components/Loading";
import sortedStores from "@lib/sortedStores";
import filterStores from "@lib/filterStores";
import Alert from "@components/Alert";

const StoreSelectModal = ({
  onStoreSelect,
  selectedStore,
  stores,
  regions,
  getStores,
  getRegions,
}) => {
  const storesData = useMemo(
    () =>
      sortedStores({
        storesData: stores,
        stickyStore: selectedStore,
      }),
    [stores, selectedStore]
  );

  const [regionIdFilter, setRegionIdFilter] = useState();
  const [storeNameFilter, setStoreNameFilter] = useState("");

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const promises = [];

      if (!regions) {
        promises.push(getRegions());
      }

      if (!stores) {
        promises.push(getStores());
      }

      if (promises.length) {
        await Promise.all(promises);
      }

      setIsLoading(false);
    };

    fetchData();
  }, []);

  const handleFiltersChange = ({ regionId, storeSearch }) => {
    if (regionId !== regionIdFilter) {
      setRegionIdFilter(regionId);
    }

    if (storeSearch && storeSearch.length > 2) {
      setStoreNameFilter(storeSearch);
    } else if (!storeSearch || storeSearch.length <= 2) {
      setStoreNameFilter("");
    }
  };

  const filteredStores = filterStores({
    storesData,
    regionId: regionIdFilter,
    storeName: storeNameFilter,
  });

  const hasStores = filteredStores.length > 0;

  return (
    <Modal
      header={<div className="text-[18px]">Magazin favorit</div>}
      id="StoreSelectModal"
    >
      {isLoading ? (
        <Loading height={100} />
      ) : (
        <>
          <StoresFilters
            regions={regions}
            onFiltersChange={handleFiltersChange}
          />
          {hasStores ? (
            <StoresList storesData={filteredStores}>
              <StoreSelectModalStoreCard
                onStoreSelect={onStoreSelect}
                selectedStoreId={selectedStore?.id}
              />
            </StoresList>
          ) : (
            <div className="mt-[20px]">
              <Alert type="error" showIcon>
                Nu am gasit un magazin care sa indeplineasca criteriile
                filtrelor selectate.
              </Alert>
            </div>
          )}
        </>
      )}
    </Modal>
  );
};

export default connect(
  (state) => ({ regions: state.user.regions, stores: state.stores.data }),
  { getRegions, getStores }
)(StoreSelectModal);
